exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50}.h1{font-weight:500;font-size:2.2rem;line-height:2.6rem}.body,.h1{color:#161c2d}.banner{font-weight:300;font-size:2rem;color:#00838f}h2{font-weight:400}ul{list-style-type:none;padding:0}li{display:inline-block;margin:0 10px}a{color:#42b983}.container{position:relative;text-align:center;width:80%}.centered{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.label{color:#bdbdbd;margin-bottom:10px}.text-color{color:#00838f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ededa7fe","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 30
// module chunks = 0